import { selectFilteredReportsAggs } from './selectors.filteredReportsAggs';

export { 
  selectFilteredReportsAggs
}

export default {
  selectFilteredReportsAggs
}